// hooks/useTrackComponentMount.js
import { useEffect } from 'react';
import LogRocket from 'logrocket';
import { getDefaultAnalyticsTraits } from '../helpers/analytics'; // Adjust path if needed

/**
 * Hook to track an event when a component mounts on the client-side.
 * Uses RudderStack and LogRocket.
 * @param {string} eventName - The name of the event to track.
 * @param {object} properties - Additional properties for the RudderStack event.
 */
const useTrackComponentMount = (eventName: string, properties = {}) => {
  useEffect(() => {
    // This code only runs on the client-side after the component has mounted

    // RudderStack Track
    if (typeof window !== 'undefined' && window.rudderanalytics) {
      try {
        window.rudderanalytics.track(eventName, {
          ...getDefaultAnalyticsTraits(),
          ...properties,
        });
      } catch (error) {
        console.error('RudderStack track failed:', error);
      }
    } else if (typeof window !== 'undefined') {
      console.warn(`RudderStack analytics not available when trying to track event: ${eventName}`);
    }

    // LogRocket Track
    try {
      LogRocket.track(eventName);
    } catch (error) {
      // handle if LogRocket might not be initialized yet
      console.error('LogRocket track failed:', error);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Run only once on mount
};

export default useTrackComponentMount;
